import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const DesiccantAirDryerIcon = ({
  width = 21,
  height = 22,
  color,
  ...rest
}: {
  width?: number;
  height?: number;
  color?: string;
}) => {
  const { token } = useToken() as unknown as CustomThemeToken;
  const currentColor = color ?? token.colorText;

  return (
    <svg width={width} height={height} viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M4.5 0C5.82683 0.0126852 7.01307 0.29385 7.83398 0.554688C8.56224 0.786227 8.99982 1.48484 9 2.24902V5.00488H12V2.22656C12.0002 1.47603 12.4219 0.786708 13.1348 0.551758C13.9567 0.280862 15.1561 -0.00894159 16.5 0.00390625C17.8268 0.0165914 19.0131 0.297756 19.834 0.558594C20.5622 0.790134 20.9998 1.48875 21 2.25293V15.9346C21 16.6027 20.6604 17.2261 20.0312 17.4512C19.4496 17.6592 18.6054 17.8762 17.5 17.9629V21.5039C17.4999 21.78 17.2761 22.0039 17 22.0039H16.5205C16.5137 22.0042 16.5069 22.0059 16.5 22.0059H4.51855C4.51238 22.0061 4.50623 22.0078 4.5 22.0078H3.5C3.22401 22.0078 3.00025 21.7837 3 21.5078V17.9082C2.1381 17.8025 1.46113 17.6212 0.970703 17.4463C0.340723 17.2213 0 16.5977 0 15.9287V2.22266C0.000158447 1.47213 0.421935 0.782801 1.13477 0.547852C1.95668 0.276955 3.15614 -0.0128478 4.5 0ZM9 15.9307C8.99999 16.5988 8.66036 17.2222 8.03125 17.4473C7.36476 17.6856 6.35408 17.9372 5 17.9883V20.0059H15.5V17.9629C14.3959 17.8756 13.5523 17.6576 12.9707 17.4502C12.3407 17.2252 12 16.6016 12 15.9326V11.0049H9V15.9307Z"
        fill={currentColor}
        fillOpacity="0.85"
      />
    </svg>
  );
};

export default DesiccantAirDryerIcon;
